import { Box, Chip } from '@mui/material';
import { ASSUMED_ABOVE_RANGE_VALUE, CONCENTRATION_UNITS } from '../../constants/report';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

export const BubbleChartChipMeaning = () => {
  const { theme } = useThemeContext();
  const boxStyles = {
    display: 'flex',
    margin: '15px 0px',
    gap: 0.5,
  };
  const chipStyles = {
    fontSize: '12px',
    backgroundColor: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chipStyles.backgroundColor,
    height: '26px',
    width: '106px',
    color: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chipStyles.color,
  };
  return (
    <Box
      sx={{
        color: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.box.color,
        display: { xs: 'block', md: 'flex' },
        gap: 1,
      }}
    >
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Not detected
            </div>
          }
          sx={{
            ...chipStyles,
            color: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.notDetected.color,
          }}
        />{' '}
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Detected (low)
            </div>
          }
          sx={{
            ...chipStyles,
            color: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.belowRange.color,
            '& .MuiChip-label': {
              padding: '0',
              whiteSpace: 'normal',
              textAlign: 'center',
            },
          }}
        />{' '}
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Detected
            </div>
          }
          sx={{
            ...chipStyles,
            backgroundColor: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.detected.backgroundColor,
          }}
        />{' '}
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Inconclusive
            </div>
          }
          sx={{
            ...chipStyles,
            backgroundColor:
              theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.inconclusive.backgroundColor,
            color: theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.inconclusive.color,
            border: `2px solid ${theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.inconclusive.borderColor}`,
          }}
        />{' '}
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              &gt; {ASSUMED_ABOVE_RANGE_VALUE} {CONCENTRATION_UNITS}
            </div>
          }
          sx={{
            ...chipStyles,
            backgroundColor:
              theme.custom.report.bubbleViewContent.bubbleChartChipMeaning.chip.aboveRange.backgroundColor,
          }}
        />{' '}
      </Box>
    </Box>
  );
};
